import { WsCore } from './ws.core';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../session.service';
import { api2 } from './api2';

export class WsAuth extends WsCore {
     constructor(http: HttpClient, session: SessionService) {
          super(http, session);
     }

     loginInternal(code) {
          return this.http
               .post(
                    api2() + '/api/auth/ob/signin/internal',
                    {
                         obClient: code,
                    },
                    {
                         params: {
                              appCtx: 'instant-planning-ob',
                         },
                    }
               )
               .toPromise();
     }

     loginExternal(obClient, obClub) {
          return this.http
               .post(
                    api2() + '/api/auth/signin/external',
                    {
                         obClub: obClub,
                         obClient: obClient,
                    },
                    {
                         params: {
                              appCtx: 'instant-planning-ob',
                         },
                    }
               )
               .toPromise();
     }

     logout() {
          return this.http
               .post(
                    api2() + '/api/auth/signout',
                    {},
                    {
                         params: {
                              appCtx: 'instant-planning-ob',
                         },
                    }
               )
               .toPromise();
     }
}
